import styled from 'styled-components'
import { colors, fontSizes, fontWeights, breakpoints, zIndex } from '@/styles'
import { ParagraphSmall } from '../text'

const DropdownWrapper = styled.div`
  display: flex;
  position: fixed;
  z-index: ${zIndex.navDropdown};
  right: 157px;
  top: 55px;
  align-self: right;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  width: 382px;
  margin-top: 4px;
  background-color: ${colors.white};
  border: 1px solid ${colors.grey88};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    border: none;
    box-shadow: none;
    width: 100%;
    margin: 0;
    position: relative;
    right: 0;
    top: 0;
  }
`

const SmallText = styled(ParagraphSmall)`
  color: ${colors.grey40};
`

const TooltipText = styled.span`
  color: ${colors.white};
  font-size: ${fontSizes.small};
`

const Line = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  height: 1px;
`

const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 0;
`

const Indicators = styled(Row)`
  justify-content: space-between;
  margin-top: -2px;
  padding: 0;
  color: ${colors.grey64};
  font-size: 10px;
  font-weight: 600;
`

const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const SectionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
`

const HeaderItems = styled(Col)`
  gap: 4px;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  padding: 10px;
  background: ${colors.blue96};
`

const LargeText = styled.div`
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.medium};
`

const SecondaryText = styled.div`
  font-size: 12px;
  margin-top: 2px;
  color: ${colors.grey40};
`

const LinkText = styled.a`
  color: ${colors.link};
  margin-left: 5px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  gap: 22px;
`

const Footer = styled.div`
  display: flex;
  padding: 12px 16px;
  background: ${colors.grey96};
  border-top: 1px solid ${colors.grey88};
  font-size: 14px;
`

export {
  DropdownWrapper,
  SmallText,
  TooltipText,
  Line,
  Row,
  Indicators,
  SectionTitle,
  SectionContent,
  Col,
  IconWrapper,
  LargeText,
  LinkText,
  Content,
  HeaderItems,
  SecondaryText,
  Footer
}
